module.exports = __webpack_public_path__ + "img/iconindustriesfunding-white-text-only-powered.15e4c15f.png";